import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { add10yearsFromNow, formatDate, isDateValid } from '../../../lib/script';
import { useCanEdit, useUserTabEditPermissionDisabled, useCanEditArchived } from '../../../lib/usersPermissions';

import "react-datepicker/dist/react-datepicker.css";
import classes from './DatepickerWithLabel.module.css'
import RemoveDataConfirmationModal from '../RemoveDataConfirmationModal';

import { datesMessageGlobal } from '../../../lib/dateScripts';
import { parseApiDateOrDateTime } from '../../../lib/dateParsing';
import BodySimpleModalV3 from '../modal/BodySimpleModalV3';
import { getDay } from 'date-fns';


const DatepickerWithLabel = ({label, defaultDate, name, action, identifier, setStyle, disabled, minDate, nofuture, required, textRight, borderRed, disableDaysModal, apiDisabled, showApiLoader}) => {

    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.permissionType ? identifier?.permissionType : identifier?.type) 

    const [isfocused, setIsFocused] = useState(false)

    // Parse the API date deterministically. `parseApiDateOrDateTime` interprets
    // bare "YYYY-MM-DD" as local midnight (no UTC shift) so the picker selects
    // the same calendar day in every timezone.
    const [startDate, setStartDate] = useState(() => parseApiDateOrDateTime(defaultDate))


    const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

    const handleCalendarOpen = () => {
        if (!userPermissionDisabled) { // check for user permission first
            setIsFocused(true)
        }
    }

    let typingTimer;                //timer identifier
    const doneTypingInterval = 0;  //time in ms, 5 seconds for example  

    const datePickerChangehandler = (date) => {
        if (!userPermissionDisabled) { // check for user permission first
            // clearTimeout(typingTimer);  
            // typingTimer = setTimeout(finnishedWriting.bind(this, date), doneTypingInterval);
            setStartDate(date)
            if (action) {
                const formattedDate = formatDate(date)
                // Let focus/click transitions complete before firing heavy quick-update handlers.
                setTimeout(() => {
                    action({
                        data: {value: formattedDate},
                        identifier: identifier,
                        option: {
                            label: formattedDate,
                            value: formattedDate
                        }
                    })
                }, 0)
            }
        }        
    }

    // const finnishedWriting = (date) => {
    //     setStartDate(date)
    //     if (action) {
    //         action({
    //             data: {value: formatDate(date)},
    //             identifier: identifier,
    //             option: {
    //                 label: formatDate(date),
    //                 value: formatDate(date)
    //             }
    //         })
    //     }
    // }

    function clearSelectionHandler() {
        if (!userPermissionDisabled) { // check for user permission first
            if (startDate) {
                setOpenConfirmationModal(true)
            }
        }
        
    }
    function closeConfirmationModal() {
        setOpenConfirmationModal(false)
    }

    function removeSelection() {
        if (!userPermissionDisabled) { // check for user permission first
            setIsFocused(false)
            setStartDate(null) 
            if (action) {
                setTimeout(() => {
                    action({
                        data: {value: null},
                        identifier: identifier
                    })
                }, 0)
            }
            setOpenConfirmationModal(false)
        }
        
    }

    const isWeekday = (date) => {
        const day = getDay(date);
        return day !== 0 && day !== 6;
    };

    useEffect(() => {
        const parsed = parseApiDateOrDateTime(defaultDate)
        if (parsed) {
            setIsFocused(true)
            setStartDate(parsed)
        } else {
            setStartDate(null)
        }
    }, [defaultDate])

    // let offsetDate = null;
    // if (startDate) {
    //     offsetDate = new Date(new Date(startDate).getTime() + (new Date(startDate).getTimezoneOffset() * 60000));
    //     // offsetDate = new Date(startDate).toLocaleDateString();
    // } else {
    //     offsetDate = startDate;
    // }

    const isDisabled = Boolean(apiDisabled || disabled || editArchivedDisabled || userPermissionDisabled)

    return <div className={classes.full_width}>
        <BodySimpleModalV3 normalEvent={true} message={datesMessageGlobal(startDate)} disabled={!startDate || disableDaysModal}>
            <div className={`${classes.datepicker_container} ${borderRed ? classes.border_red : ''} ${setStyle ? classes[setStyle] : ''} ${textRight ? 'datepicker-container-right' : ''}`} >     
                <div className={`${classes.fields} ${(isfocused && label) && classes.focused}`}>
                        {label && <span className={classes.label}>{label}{required ? <span className={'required'}>*</span> : ''}{showApiLoader && apiDisabled ? <span className="loader dark field_label_loader" /> : null}</span>}
                        <DatePicker 
                            // dateFormat="M/d/yyyy"
                            name={name}
                            wrapperClassName="label-date-picker" 
                            selected={startDate} 
                            onChange={(date) => datePickerChangehandler(date)}
                            // onClickOutside={blurHandler}
                            onCalendarOpen={handleCalendarOpen}
                            // Fixed popper keeps calendar under the input and above modal overflow (avoids centered withPortal overlay)
                            popperProps={{
                                strategy: 'fixed',
                            }}
                            portalId="datepicker-portal"
                            disabled={isDisabled}
                            minDate={minDate}
                            // filterDate={onlyWeekDayes ? isWeekday : undefined}
                            showYearDropdown
                            showMonthDropdown
                            className={classes.date_picker}
                            maxDate={nofuture ? new Date() : add10yearsFromNow()}
                            required={required}
                            autoComplete='off'
                            dateFormat="M/d/yyyy"
                        />   
        
                        {/* <input className={classes.date_picker} aria-label="Date" type="date" value={startDate} onChange={onChange}/> */}

                        <div className={classes.icon}><i className='ti ti-calendar'></i></div>   

                        <button type='button' className={`${classes.clear_select} custom_select_clear_button`} onClick={clearSelectionHandler} disabled={isDisabled}><i className='ti ti-x'></i></button>
                        {openConfirmationModal && <RemoveDataConfirmationModal closeModal={closeConfirmationModal} removeData={removeSelection}/>}
                    </div>
            </div>
        </BodySimpleModalV3> 
        
    </div>
}

export default DatepickerWithLabel